import { useIntegratedForm } from '../../../forms/use-integrated-form';
import { BoloPanelFormType, BoloPanelView } from '@mark43/cad-api';
import { useBoloPanelMetadataStore } from '../state/bolo-panel-metadata-context';
import { useRefreshBoloPanel } from '../form/use-refresh-bolo-data';
import { useBoloApi } from '../state/use-bolo-api';
import { Button } from '@cad-arc';
import { observer } from 'mobx-react-lite';

export const ExpireAndReactivateBoloButton = observer(() => {
    const { form } = useIntegratedForm<BoloPanelFormType>();
    const boloMetadataStore = useBoloPanelMetadataStore();
    const refreshBoloPanel = useRefreshBoloPanel({ boloForm: form, boloMetadataStore });
    const { expireBolo, reactivateBolo } = useBoloApi({});
    const isExpired = !!boloMetadataStore.state?.metadata?.actualExpirationDateUtc;

    const refresh = (boloPanelView?: BoloPanelView) => {
        if (!boloPanelView) {
            return;
        }

        refreshBoloPanel(boloPanelView);

        form.trigger();
    };

    const onExpire = async () => {
        const id = boloMetadataStore?.state?.metadata?.boloId;
        if (!id) {
            return;
        }

        const newPanel = (await expireBolo.mutateAsync(id)).data?.data?.boloPanelView;
        refresh(newPanel);
    };

    const onReactivate = async () => {
        const id = boloMetadataStore?.state?.metadata?.boloId;
        if (!id) {
            return;
        }

        const newPanel = (await reactivateBolo.mutateAsync(id)).data?.data?.boloPanelView;
        refresh(newPanel);
    };

    return (
        <Button variant="outline" onClick={!isExpired ? onExpire : onReactivate}>
            {!isExpired ? 'Expire' : 'Reactivate'}
        </Button>
    );
});
